import api from './api';

export function getIdentificationTypes() {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/clients/tipo-documento`);
}

export function getGenders() {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/clients/genero`);
}

export function getSpecialConditions() {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/clients/condicion-especial`);
}

export function getPrincipalesActividadesEconomicas() {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/clients/principales-actividades-economicas`);
}

export function getAllActividadesEconomicas() {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/clients/all-actividades-economicas`);
}

export function getPaisesMundo() {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/clients/paises-mundiales`);
}

export function calculadoraRiesgo(data) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/calculadora-riesgo/calcular`,data);
}

